import React, {useEffect, useState} from "react";
import Modal, {IModal} from "components/UI/Modal/Modal";

export type ModalVariant = "installMetamask" | "noNFTs" | "howToBuy"

interface IModalButtonProps extends IModal {
    variant: ModalVariant
    children?: React.ReactNode;
}

const ModalButton: React.FC<IModalButtonProps> = (
    {
        variant,
        isOpen,
        setIsOpen,
    }
) => {
    const [title, setTitle] = useState<string>("");
    const [buttonText, setButtonText] = useState<string>("");
    const [url, setUrl] = useState<string>("");

    useEffect(() => {
        if (variant === "installMetamask") {
            setTitle("Please install metamask extension!");
            setButtonText("Install metamask");
            setUrl("https://metamask.io/download/");
        }
        if (variant === "noNFTs") {
            setTitle("You are not an IggyBoy NFT holder. Buy some NFT to have an opportunity to vote.");
            setButtonText("Buy now");
            setUrl("https://opensea.io/collection/iggyboy-1athstudio");
        }
    }, [variant]);
    return (
        <Modal title={title} isOpen={isOpen} setIsOpen={setIsOpen}>
            <a href={url} target="_blank" rel="noreferrer"
               className="modal__btn-action decor-text button">{buttonText}</a>
        </Modal>
    );
};

export default ModalButton;